import {
  MenuItemOption as ChakraMenuItemOption,
  MenuItemOptionProps as ChakraMenuItemOptionProps,
  forwardRef,
} from '@chakra-ui/react'
import { SwashbuckleComponentProps } from '../../types'

type MenuItemOptionProps = SwashbuckleComponentProps<ChakraMenuItemOptionProps>

export const MenuItemOption = forwardRef<MenuItemOptionProps, 'div'>(
  (props, ref) => {
    const { 'data-qa': dataQa, className, ...chakraMenuItemOptionProps } = props

    return (
      <ChakraMenuItemOption
        ref={ref}
        data-qa={dataQa}
        className={className}
        {...chakraMenuItemOptionProps}
      />
    )
  }
)

// Without this line, the check icons don't work! This is
// important!
MenuItemOption.id = 'MenuItemOption'

MenuItemOption.displayName = 'MenuItemOption'
